"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  SET_PANEL: null,
  BACK: null,
  SEARCH: null,
  SELECT_FILE: null,
  SET_FILTER: null,
  TRACK_INTERACTION: null,
  UPDATE_DETAIL_HEIGHT: null,
  SELECT_STOCK_FILE: null,
  ADD_FOLDER_SUCCEEDED: null,
  ACQUIRE_IMAGE_ATTEMPTED: null,
  ACQUIRE_IMAGE_SUCCEEDED: null,
  ACQUIRE_IMAGE_FAILED: null,
  CLEAR_FILE_FOR_EDITING: null,
  FETCH_FILE_FOR_EDITING_ATTEMPTED: null,
  FETCH_FILE_FOR_EDITING_FAILED: null,
  FETCH_FILE_FOR_EDITING_SUCCEEDED: null,
  SAVE_FILE_EDIT_ATTEMPTED: null,
  SAVE_FILE_EDIT_SUCCEEDED: null,
  SAVE_FILE_EDIT_FAILED: null,
  SELECT_IMAGE_OPTIMIZATION_SETTING: null
});

exports.default = _default;
module.exports = exports.default;